import { GutXAxisFlagKey } from '@repo/ui';
import type { GutXAxisFlagLevel } from '@repo/types';
import styles from './CardReferences.module.css';

const FLAGS_KEYS: GutXAxisFlagLevel[] = ['low', 'moderate', 'high'];

export default function CardReferences() {
  return (
    <div className={styles.container}>
      {FLAGS_KEYS.map(fk => (
        <GutXAxisFlagKey key={fk} flagLevel={fk} />
      ))}
    </div>
  );
}
